// T119 — eyebrow section header (the `text-xs uppercase tracking-wide
// text-slate-500` heading + optional hint used across Profile/Settings/Dashboard
// sections). `tone="accent"` for the brand-coloured variant; right-aligned
// `children` slot for a "clear" link or count.
export default function SectionHeader({ title, hint, tone = 'muted', as: As = 'h2', children }) {
  const t = tone === 'accent' ? 'text-brand-500' : 'text-slate-500';
  return (
    <div className="flex items-baseline justify-between gap-2">
      <div>
        <As className={`text-xs uppercase tracking-wide ${t}`}>{title}</As>
        {hint && <p className="mt-0.5 text-xs text-slate-500">{hint}</p>}
      </div>
      {children}
    </div>
  );
}
